import React, { Component } from "react";
import CohortService from "../../services/cohortservice";

// Reward incrementality — compares Reward / Natural / Other cohorts on repeat,
// velocity, value and retention. Reads Admin_RTo3_Cohorts via the Store WebAPI.
const COH = {
  Reward: { label: "Reward", color: "#a9781f", bg: "#f6edda" },
  Natural: { label: "Natural", color: "#1f8a4c", bg: "#e5f5ec" },
  Other: { label: "Other coupon", color: "#0b6bb3", bg: "#e6f1fb" },
};
const ORDER = ["Reward", "Natural", "Other"];

export default class Cohorts extends Component {
  constructor(props) {
    super(props);
    this.service = new CohortService();
    this.state = { rows: [], from: "", to: "", loading: true };
  }
  componentDidMount() { this.load(); }
  load = async () => {
    this.setState({ loading: true });
    const r = await this.service.getCohorts(this.state.from || null, this.state.to || null);
    this.setState({ rows: Array.isArray(r) ? r : [], loading: false });
  };
  ymd = (d) => { const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000); return z.toISOString().slice(0, 10); };
  setRange = (from, to) => { this.setState({ from, to }, this.load); };
  applyRange = () => this.load();
  presetDays = (n) => { const t = new Date(); this.setRange(this.ymd(new Date(Date.now() - (n - 1) * 864e5)), this.ymd(t)); };
  presetMonth = () => { const t = new Date(); this.setRange(this.ymd(new Date(t.getFullYear(), t.getMonth(), 1)), this.ymd(t)); };
  inr = (n) => "₹" + Math.round(Number(n) || 0).toLocaleString("en-IN");
  pctv = (a, b) => (b > 0 ? Math.round((a / b) * 100) : 0);

  byCohort() { const m = {}; (this.state.rows || []).forEach((r) => { m[r.cohort] = r; }); return m; }

  verdict() {
    const b = this.byCohort(), rw = b.Reward, na = b.Natural;
    if (!rw || !na || !rw.customers || !na.customers) return null;
    const rwRep = this.pctv(rw.repeat2, rw.customers), naRep = this.pctv(na.repeat2, na.customers);
    const revDiff = Math.round((rw.revPerCust || 0) - (na.revPerCust || 0));
    if (rwRep > naRep + 5) {
      const mult = naRep > 0 ? (rwRep / naRep).toFixed(1) + "× more" : "more";
      return { good: true, text: "Reward customers repeat " + mult + (revDiff > 0 ? " and are worth " + this.inr(revDiff) + " more each" : "") + " than organic — the reward is buying loyalty, not just discounting." };
    }
    if (rwRep + 5 < naRep) return { good: false, text: "Organic customers repeat more than rewarded ones — the reward isn't driving loyalty; worth reconsidering the spend." };
    return { good: null, text: "Reward and organic customers repeat about the same — the reward isn't materially changing behaviour yet." };
  }

  renderTable() {
    const b = this.byCohort();
    const cell = (v, suf) => (v === null || v === undefined ? <span className="co-na">—</span> : (v + (suf || "")));
    return (
      <div className="co-scroll"><table className="co-tbl">
        <thead><tr>
          <th>Cohort</th><th className="n">Customers</th><th className="n">Repeat ≥2</th><th className="n">Repeat ≥3</th>
          <th className="n">Days to 2nd</th><th className="n">Avg order</th><th className="n">Rev / cust</th>
          <th className="n">Ret 30d</th><th className="n">Ret 60d</th><th className="n">Ret 90d</th>
        </tr></thead>
        <tbody>
          {ORDER.filter((k) => b[k]).map((k) => {
            const r = b[k], c = COH[k];
            const rep2 = this.pctv(r.repeat2, r.customers), rep3 = this.pctv(r.repeat3, r.customers);
            return (
              <tr key={k}>
                <td><span className="co-chip" style={{ color: c.color, background: c.bg }}>{c.label}</span></td>
                <td className="n">{r.customers}</td>
                <td className="n"><b>{rep2}%</b><small> {r.repeat2}</small></td>
                <td className="n">{rep3}%<small> {r.repeat3}</small></td>
                <td className="n">{r.avgDaysTo2nd == null ? <span className="co-na">—</span> : r.avgDaysTo2nd + "d"}</td>
                <td className="n">{this.inr(r.avgOrderValue)}</td>
                <td className="n"><b>{this.inr(r.revPerCust)}</b></td>
                <td className="n">{cell(r.ret30, "%")}</td>
                <td className="n">{cell(r.ret60, "%")}</td>
                <td className="n">{cell(r.ret90, "%")}</td>
              </tr>
            );
          })}
        </tbody>
      </table></div>
    );
  }

  renderRepeat() {
    const b = this.byCohort();
    const rows = ORDER.filter((k) => b[k]);
    if (!rows.length) return null;
    return (
      <div className="co-card">
        <div className="co-ch">Repeat funnel · orders placed</div>
        <div className="co-chs">1st → 2nd → 3rd order, per cohort</div>
        {rows.map((k) => {
          const r = b[k], c = COH[k], base = r.customers || 1;
          const seg = (n, o) => <div className="co-rseg" style={{ flex: Math.max(0.04, n / base), background: c.color, opacity: o }} title={n} />;
          return (
            <div className="co-rrow" key={k}>
              <span className="co-rlab" style={{ color: c.color }}>{c.label}</span>
              <div className="co-rbars">{seg(r.customers, 1)}{seg(r.repeat2, 0.6)}{seg(r.repeat3, 0.32)}</div>
              <span className="co-rnums">{r.customers} · {r.repeat2} · {r.repeat3}</span>
            </div>
          );
        })}
        <div className="co-rlegend">Bars: 1st order · 2nd order · 3rd order (counts at right)</div>
      </div>
    );
  }

  render() {
    const v = this.verdict();
    return (
      <div className="co-root">
        <style>{CO_CSS}</style>
        <div className="co-head">
          <h1>Reward incrementality</h1>
          <p>Are rewarded customers worth more than organic ones? Reward vs Natural vs Other-coupon — repeat, speed, value and retention, side by side.</p>
        </div>

        <div className="co-drange">
          <span className="co-drlab">Enrolled</span>
          <button className={"co-drchip" + (!this.state.from && !this.state.to ? " on" : "")} onClick={() => this.setRange("", "")}>All time</button>
          <button className="co-drchip" onClick={() => this.presetDays(30)}>Last 30 days</button>
          <button className="co-drchip" onClick={this.presetMonth}>This month</button>
          <span className="co-drcustom">
            <input type="date" value={this.state.from} onChange={(e) => this.setState({ from: e.target.value })} />
            <span className="co-drto">→</span>
            <input type="date" value={this.state.to} onChange={(e) => this.setState({ to: e.target.value })} />
            <button className="co-drapply" onClick={this.applyRange}>Apply</button>
          </span>
        </div>

        <div className="co-card">
          <div className="co-ch">Cohort comparison</div>
          <div className="co-chs">Same yardsticks, three ways customers converted — read across the rows.</div>
          {this.state.loading ? <div className="co-empty">Loading…</div>
            : (this.state.rows && this.state.rows.length ? this.renderTable() : <div className="co-empty">No conversions in this range yet — this fills in as enrolled customers place orders.</div>)}
          {v && <div className={"co-verdict " + (v.good === true ? "good" : v.good === false ? "bad" : "neu")}><b>Verdict:</b> {v.text}</div>}
        </div>

        {this.renderRepeat()}

        <div className="co-foot">Cohort = how a customer first converted. Retention @Nd = ordered again ≥N days after their first order (only customers old enough to have matured N days count). Source: read-only Welcome-Reward + order data.</div>
      </div>
    );
  }
}

const CO_CSS = `
.co-root{--c-card:#fff;--c-ink:#231a2b;--c-ink2:#4f4557;--c-muted:#7a6f83;--c-faint:#a89fb0;--c-line:#e8e2ee;--c-line2:#f0ecf4;--c-brand:#c71c78;font-variant-numeric:tabular-nums;color:var(--c-ink);padding:4px 2px 40px}
.co-head h1{margin:0 0 2px;font-size:22px}.co-head p{margin:0 0 16px;color:var(--c-muted);font-size:13.5px;max-width:760px}
.co-drange{display:flex;align-items:center;flex-wrap:wrap;gap:8px;margin:0 0 16px}.co-drlab{font-size:11px;font-weight:700;letter-spacing:.04em;color:var(--c-muted);text-transform:uppercase;margin-right:2px}
.co-drchip{border:1px solid var(--c-line);background:var(--c-card);color:var(--c-ink2);border-radius:8px;padding:6px 12px;font-size:12.5px;font-weight:600;cursor:pointer}.co-drchip.on{background:var(--c-ink);color:#fff;border-color:var(--c-ink)}
.co-drcustom{display:inline-flex;align-items:center;gap:6px;background:var(--c-card);border:1px solid var(--c-line);border-radius:8px;padding:4px 8px}.co-drcustom input[type=date]{border:0;background:transparent;font:inherit;font-size:12.5px;color:var(--c-ink);outline:none}.co-drto{color:var(--c-faint);font-size:12px}.co-drapply{border:0;background:var(--c-brand);color:#fff;border-radius:6px;padding:5px 12px;font-size:12.5px;font-weight:700;cursor:pointer}
.co-card{background:var(--c-card);border:1px solid var(--c-line);border-radius:14px;padding:16px 18px;margin:0 0 16px;max-width:900px}
.co-ch{font-weight:700;font-size:15px}.co-chs{color:var(--c-muted);font-size:12.5px;margin:2px 0 12px}
.co-scroll{overflow-x:auto}.co-tbl{width:100%;border-collapse:collapse;min-width:640px}
.co-tbl th,.co-tbl td{padding:9px 8px;font-size:13.5px;border-bottom:1px solid var(--c-line2);text-align:left;white-space:nowrap}
.co-tbl th{color:var(--c-muted);font-size:10.5px;text-transform:uppercase;letter-spacing:.03em;border-bottom:1px solid var(--c-line)}
.co-tbl td.n,.co-tbl th.n{text-align:right}.co-tbl tbody tr:last-child td{border-bottom:0}
.co-tbl small{color:var(--c-faint);font-weight:400;font-size:11px}
.co-chip{display:inline-block;font-size:11.5px;font-weight:700;padding:2px 10px;border-radius:999px}
.co-na{color:var(--c-faint)}
.co-verdict{margin-top:14px;border-radius:9px;padding:10px 13px;font-size:13px;line-height:1.5}
.co-verdict.good{background:#e5f5ec;color:#155e35}.co-verdict.bad{background:#fbe7e4;color:#a3271b}.co-verdict.neu{background:#f0ecf4;color:#4f4557}
.co-rrow{display:flex;align-items:center;gap:12px;margin:8px 0}.co-rlab{width:110px;flex:none;font-weight:700;font-size:13px}.co-rbars{flex:1;display:flex;gap:4px;height:18px}.co-rseg{border-radius:3px;min-width:3px}.co-rnums{width:110px;flex:none;text-align:right;font-size:12.5px;color:var(--c-ink2)}
.co-rlegend{color:var(--c-muted);font-size:11.5px;margin-top:8px}
.co-empty{color:var(--c-faint);font-size:13px;padding:8px 0}
.co-foot{color:var(--c-muted);font-size:11.5px;max-width:900px;line-height:1.6}
`;
